<div class="state-listing">
  <div class="state-listing__wrapper">
    <h1 class="state-listing__header">Airports by State/Territory</h1>
    <div class="state-airports__subheader">
      <a [routerLink]="['/']">&laquo; Back to Home</a>
    </div>
    <div class="state-listing__body">
      <p class="state-listing__description">
        Click on a US state or territory to see all of its airports.
      </p>
      <div class="state-listing__listing">
        <div *ngFor="let state of STATES" class="state-listing__state">
          <a [routerLink]="['/airports/state', state.stateCode]" class="state-listing__state-link">
            {{getStateName(state.name)}}
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
